import React from 'react';
import { Button } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * 現在の検索条件モーダルのフッター
 */
interface Props {
  /** 閉じるボタンのクリックハンドラ */
  onClickClose: React.MouseEventHandler<HTMLButtonElement>;
  /** 保存ボタンのクリックハンドラ */
  onClickSave: React.MouseEventHandler<HTMLButtonElement>;
}

/**
 * 現在の検索条件モーダルのフッターを表示するコンポーネント
 * @param {Props} props - コンポーネントに渡されるプロパティ
 * @returns {JSX.Element} 現在の検索条件モーダルのフッターを表示する要素
 */
export const CurrentConditionModalFoot: React.FC<Props> = ({
  onClickSave,
  onClickClose,
}) => {
  return (
    <div className={styles.currentConditionModalFoot}>
      <Button
        onClick={onClickSave}
        variant="green"
        style={{ marginRight: '12px' }}
      >
        保存する
      </Button>
      <Button onClick={onClickClose} variant="outline_gray">
        保存しない
      </Button>
    </div>
  );
};
